export default __webpack_public_path__ + "static/media/gallery-wip-pommel-cap_04.62e0c0a2.jpg";